import Ventus from './window/ventus'

import { EventEmitter } from './EventEmitter.js'
import { storage, encrypt } from './utils/tools.js';

// data数据监听
const _watchMap = new Map();
const _queuing = new Map();
const _data = { isLogined: false, token: '', _queuing, contentLoaded: false }

// 缓存应用
const cacheApp = storage.get('cacheApp') || {};

let _self = null;

function setData(target, property, value, receiver) {
    if (_watchMap.has(property)) {
        let cbs = _watchMap.get(property)
        if (cbs) {
            cbs.forEach(item => {
                item(value)
            })
        }
    }

    return Reflect.set(target, property, value, receiver)
}

function deleteData(target, property) {
    if (_watchMap.has(property)) {
        _watchMap.delete(property)
    }
    return Reflect.deleteProperty(target, property)
}


const $data = new Proxy(_data, {
    set: (target, property, value, receiver) => {
        return setData(target, property, value, receiver)
    },
    deleteProperty: (target, property) => {
        return deleteData(target, property)
    }
})

/**
 * @class proc
 * @classdesc provider通信进程
 */
export class Proc extends EventEmitter {
    $root = null;

    key = 'Hexu'


    constructor() {
        super();
        _self = this;
        this.createRootNode('body');
        this.wm = new Ventus.WindowManager();

    }

    /**
     * 对属性进行监听
     * @param {String} key 
     * @param {Function} cb 
     */
    watch(key, cb) {
        const watchs = _watchMap.get(key) || [];
        _watchMap.set(key, [...watchs, cb]);
    }



    /**
  * 获取数据模型
  */
    get data() {
        return $data
    }
    /**
     * 直接赋值数据模型
     * @description 直接赋值将放置到anonymousData匿名数据数组中，更新data中的数据请使用setData({})方法，或使用“ . ”运算符对data中的属性赋值
     */
    set data(val) {
        // 设置匿名数据，无建名
        if (!$data['anonymousData']) {
            $data['anonymousData'] = []
        }
        $data['anonymousData'].push(val)
    }

    /**
     * 获取匿名数据
     */
    get anonymousData(){
        return $data['anonymousData']
    }

    /**
     * 缓存
     */
    cache = new Proxy(cacheApp, {
        set: (target, property, value, receiver) => {
            if (typeof value === 'object') {
                cacheApp[property] = value
                storage.set('cacheApp', cacheApp)
            }
            return Reflect.set(target, property, value, receiver)
        }
    })

    /**
     * @description 消息列队处理
     */
    messageQueuing = {
        /**
         * 
         * @param {string} key 
         * @param {Array<any>} val 列队
         * @returns 
         */
        add(key, val = []) {
            if (!Array.isArray(val)) {
                return;
            }
            _self.data._queuing.set(key, val)
        },
        /**
         * 
         * @param {string} key 
         * @param {function} cb 消息处理程序
         * @returns 
         */
        async handler(key, cb) {
            if (typeof cb !== 'function') return;
            let $queuing = _self.data._queuing;
            let list = $queuing.get(key);
            try {
                for (let i = 0; i < list.length; i++) {
                    let bool = cb(list[i])
                    if (Object.prototype.toString.call(bool) === '[object Promise]') {
                        bool = await bool;
                    }
                    if (!bool) {
                        break;
                    }
                }
            } catch (error) {
                return false;
            }
            return true;
        },
        clear(key) {
            if (key) {
                _self.data._queuing.delete(key)
            } else {
                _self.data._queuing.clear()
            }
        }
    }

    /**
     * 获取新窗口打开的链接的应用名称
     * @returns {AppName}
     */
    getLinkAppName() {
        let open = window.location.href.split('@OPEN')[1];
        try {
            let encryptStr = open.split(/(\/|\?)/)[0]
            return encrypt.decrypt(encryptStr, this.key);
        } catch (error) {

        }

    }
    /**
     * 获取未解密的应用名
     * @returns {string}
     */
    getEncryptAppName() {
        let open = window.location.href.split('@OPEN')[1];
        try {
            let encryptStr = open.split(/(\/|\?)/)[0]
            return encryptStr;
        } catch (error) {
            return open
        }

    }

    /**
     * 获取链接参数
     * @param {string} name 
     * @returns 
     */
    getLinkParam(name) {
        let paramStr = window.location.href.split('@OPEN')[1];
        let paramObj = {};
        if (paramStr.indexOf("?") != -1) {
            let str = url.substr(1);
            let strs = str.split("&");
            for (let i = 0; i < strs.length; i++) {
                paramObj[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
            }
        }
        if (name) {
            return paramObj[name]
        }
        return paramObj;
    }

    /**
     * 设置数据
     * @param {Object} data
     * @returns {Boolean}
     */
    setData(data) {
        return new Promise((res, rej) => {
            try {
                Object.keys(data).forEach(key => {
                    this.data[key] = data[key]
                })
                res(true)
            } catch (error) {
                rej(error)
            }

        })

    }
    /**
	 * 获取数据并监听数据变化
	 * @param {Object} key
	 * @param {Object} callback
	 */
	getData(key, callback) {
		let val = this.data[key];
		callback(val);
		this.watch(key, (val) => {
			callback(val)
		})
	}


    /**
     * 
     * @param {HTMLElement | string} root 
     * @returns {HTMLElement}
     */
    async createRootNode(root) {

        let div = document.createElement('div');
        div.id = 'root';
        div.style.cssText = 'position: relative;';
        this.$root = div;
        if (typeof root === 'string') {
            document.querySelector(root).appendChild(this.$root)
        } else {
            root.appendChild(this.$root)
        }
        this.data.contentLoaded = true;
        return this.$root;
    }
    /**
     * 
     * @returns 当前浮动的窗口
     */
    windows() {
        return this.wm.windows();
    }

    /**
     * 创建浮动窗口
     * @param {object} options 
     * @returns 
     */
    createWindow(options = {
        x: 0,
        y: 0,
        width: 300,
        height: 300,
        title: '',
    }) {
        return this.wm.createWindow(options);
    }
}

